import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLogin: false,
  name: "",
  username: "",
  email: "",
  access_token: "",
  role: "",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.name = action.payload.name;
      state.username = action.payload.username;
      state.email = action.payload.email;
      state.access_token = action.payload.access_token;
      state.role = action.payload.role;
      state.isLogin = true;
    },
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
